import { Grid, useMediaQuery, useTheme } from '@mui/material'
import { Outlet, Route, Routes } from 'react-router-dom'

import BottomNav from '../components/navigation/BottomNav'
import TopAppBar from '../components/navigation/TopAppBar'
import PageNotFound from '../pages/404'
import Documents from '../pages/Documents'
import Earnings from '../pages/Earnings'
import HomePage from '../pages/HomePage'
import Profile from '../pages/Profile'
import Rides from '../pages/Rides'
import Schedule from '../pages/Schedule'
import Training from '../pages/Training'
import routes from '../router/routes'

const ENV_NAME = import.meta.env.VITE_ENVIRONMENT_NAME
const IS_DEV_OR_STAGING = ENV_NAME === 'staging' || ENV_NAME === 'development'

const Layout = () => {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Grid alignContent="flex-start" alignItems="flex-start" container>
      <Grid item xs={12}>
        <TopAppBar />
      </Grid>
      <Grid item xs={12}>
        <Routes>
          <Route element={<Outlet />}>
            <Route element={<HomePage />} path={routes.portal.home} />
            <Route element={<Profile />} path={routes.portal.profile} />
            {IS_DEV_OR_STAGING && (
              <Route element={<Schedule />} path={routes.portal.schedule} />
            )}
            <Route element={<Earnings />} path={routes.portal.earnings} />
            <Route element={<Rides />} path={routes.portal.rides} />
            <Route element={<Documents />} path={routes.portal.documents} />
            <Route element={<Training />} path={routes.portal.training} />
            <Route element={<PageNotFound />} path={routes.pageNotFound} />
          </Route>
        </Routes>
      </Grid>
      {isLargeScreen ? null : (
        <Grid item xs={12}>
          <BottomNav />
        </Grid>
      )}
    </Grid>
  )
}
export default Layout
